import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import {
  AppBar,
  Container,
  Box,
  IconButton,
  Toolbar,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HelpIcon from '@mui/icons-material/Help';
import AuthStatus from "./AuthStatus";
import Logo from '../images/logo-clear-white.svg';
import { HELP_URL } from '../constants';

export default function Header() {
  const [fillBar, setFillBar] = useState('transparent');

  const handleScroll = () => {
    setFillBar(window.scrollY < 10 ? 'transparent' : 'default');
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <AppBar sx={{ transition: 'background 300ms ease-out' }} position="fixed" color={fillBar} elevation={0}>
      <Container maxWidth="lg">
        <Toolbar>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton> */}
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ mt: 1 }}>
              <a href="https://opengolfsim.com"><img src={Logo} height="70" /></a>
            </Box>
          </Box>

          {/* <Button sx={{ mr: 2 }} to="/desktop" color="inherit" component={Link}>Desktop</Button>
          <Button sx={{ mr: 2 }} to="/mobile" color="inherit" component={Link}>Mobile</Button> */}
          <Box sx={{ mr: 2 }}>
            <IconButton color="inherit" onClick={() => window.open(HELP_URL)}>
              <HelpIcon />
            </IconButton>
            {/* <Button color="inherit" onClick={() => window.open(HELP_URL)}>Support</Button> */}
          </Box>

          {/* <Button to="/login" color="inherit" component={Link}>Features</Button>
          <Button to="/login" color="inherit" component={Link}>Pricing</Button> */}

          <AuthStatus />


        </Toolbar>
      </Container>
    </AppBar>
  )
}